/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import AgreementApi from '@/api/agreement';
import { AgreementSceneType } from '@/api/agreement/types';
import AuthorizationApi from '@/api/authorization';
import { postLoginInfo } from '@/api/user';
import { AgreementPo } from '@/po/agreement';
import { RouterV2Enum } from '@/router/router-names';
import Bootstrap from '@/shared/utils/bootstrap';
import { landData } from '@/shared/utils/landData';
import { updateModuleState } from '@/store';
import { Login } from '@hb/finance-login';
import { LoginError, LoginErrorType } from '@hb/finance-login/lib/login/types';
import { Toast } from '@hb/coffee';
import { Component, Prop, Mixins } from 'vue-property-decorator';
import AdvMarketingBackPopup from '@/components/adv-components/adv-marketing-back-popup';
import URLUtils from '@/shared/utils/URLUtils';
import { AgreementTypeEnum } from '@/enums/agreement-type';
import { jumpToLocal, jumpToRechargeH5 } from '@/shared/utils/jumpTo';
import { ContractSceneEnum, RechargeH5RouteEnum } from '@/enums/rechargeH5';
import { codeEnums } from '@/shared/utils/platform';
import jumpToVerifyCredit from '@/shared/verify-credit-controller';
import { VerifySceneEnum } from '@/shared/verify-credit-controller/types';
import { IS_PRERENDERING } from '@hb/coffee-prerender';
import { CallBackActionEnum, EvokeAppTypeEnums, PageVersionTypeEnums } from '../../types';
import OutRelease from '../outRelease';
import MarketingLeaving from './mixins';
import style from './index.module.scss';
import { pageFeatureConfig, LandingPageType, getAutoLoginLegalContractRoute } from '../../config';

export interface contractListDataType {
  agreementName: string;
  agreementUrl: string;
}

export interface LoginType {
  topImgUrl:string;
  title: string;
  rightImgUrl: string;
  mainBgColor: string;
}

export enum MarketType {
  login = 'login',
  brand = 'brand'
}

@Component({ name: 'NewPageWithLogin' })
export default class NewPageWithLogin extends Mixins(MarketingLeaving) {
  // 页面版本
  @Prop(String) readonly pageVersion!: PageVersionTypeEnums;

  /** 是否走 abtest 流程
   * 默认走 abtest 逻辑分流，值为 true
   * 当值为 false 时，走新版本带登录样式且在h5流程里面做个人基本信息的填写 */
  @Prop(Boolean) readonly isAbtest!: boolean;

  $refs!: {
    outRelease: InstanceType<typeof OutRelease> ;
  };

  /**
   * 当前合同协议列表
  */
  private agreementList: AgreementPo[] = [];

  /** 原始fiannce协议列表 */
  private orgFinanceAgreementList: AgreementPo[] = [];

  private agreementsTypeId: { finance: number[], platform: string[] } = {
    finance: [],
    platform: [],
  };

  private beforeLeaveBind = this.beforeLeave.bind(this);

  private async created() {
    /** 预渲染无需接口数据相关逻辑初始化 */
    if (IS_PRERENDERING) return;

    // 是否需要增加挽留弹窗的功能
    await this.getLeavingShow();

    // 增加定时器 ，防止部分场景进入页面可能触发popstate问题
    setTimeout(() => {
      window.addEventListener('popstate', this.beforeLeaveBind);
    }, 400);

    try {
      const [{ agreements }, pAgrees] = await Promise.all([
        this.isRechargeContract
          ? AgreementApi.getRechargeTypeAContracts()
          : AgreementApi.getAgreedInfo(AgreementSceneType.SMS, codeEnums.app),
        AgreementApi.getNoLoginRegisterAgrees(),
      ]);
      // 传入协议类型，落地页只需要展示臻有钱用户协议
      const financeAgreements = agreements.map(
        (item) => ({
          ...item,
          agreementName: `《${item.agreementName}》`,
        }),
      );
      /** 平台基建协议 */
      const platformAgreements = pAgrees.map(
        (item) => ({
          ...item,
          agreementName: `《${item.agreementName || ''}》`,
          id: item.agreementId,
        } as unknown as AgreementPo),
      );

      this.orgFinanceAgreementList = financeAgreements;
      this.agreementsTypeId.finance = financeAgreements.map((it) => it.id);
      this.agreementsTypeId.platform = platformAgreements.map((it) => String(it.id));
      this.agreementList = [...financeAgreements, ...platformAgreements];
    } catch {
      // do nothing;
    }
  }

  private waitHint = false;

  private redirectApp() {
    this.$emit('redirectApp');
  }

  private topImgUrl ={
    [MarketType.login]: 'https://m.hellobike.com/resource/helloyun/13612/aXp0O_topImg.png',
    [MarketType.brand]: 'https://m.hellobike.com/1fdaff02_finance-market-page-003-header_3x.png',
  }

  private title = {
    [MarketType.login]: 'https://m.hellobike.com/resource/helloyun/13612/Vot_V_title.png',
    [MarketType.brand]: 'https://m.hellobike.com/resource/helloyun/21900/sFD3K_market_title.png?x-oss-process=image/quality,q_80',
  }

  private rightImgUrl = {
    [MarketType.login]: 'https://m.hellobike.com/resource/helloyun/13612/lmpVx_rightImg.png',
    [MarketType.brand]: 'https://m.hellobike.com/resource/helloyun/21900/idt9x_market_rightImg.png?x-oss-process=image/quality,q_80',
  }

  private configList:Dictionary<LoginType> = {
    login: {
      topImgUrl: this.topImgUrl[MarketType.login],
      title: this.title[MarketType.login],
      rightImgUrl: this.rightImgUrl[MarketType.login],
      mainBgColor: '#ff3f22',
    },
    brand: {
      topImgUrl: this.topImgUrl[MarketType.brand],
      title: this.title[MarketType.brand],
      rightImgUrl: this.rightImgUrl[MarketType.brand],
      mainBgColor: '#f3dba9',
    },
  }

  // 返回当前的配置
  private get currentConfig() {
    return this.$route.path === RouterV2Enum.newRedirect
      ? this.configList.login : this.configList.brand;
  }

  // 协议名称数组
  private get ruleName() {
    return ['《用户协议及隐私政策》'];
  }

  private get contractList(): AgreementPo[] {
    const contractListArr = this.agreementList;
    const contract:AgreementPo = {
      id: -1,
      agreementType: 1,
      agreementName: '《哈啰平台服务及软件使用协议》',
      agreementUrl: 'https://hello-finance.cn-hangzhou.oss.aliyuncs.com/pro/contract/h5/ppysldy-1659607336473.html',
      signDate: '',
      isAgreed: false,
    };
    if (this.$route.path === RouterV2Enum.newRedirect) {
      return contractListArr;
    }
    return contractListArr.concat(contract);
  }

  /** 展示分屏版本 */
  private get splitVersion() {
    const pageConfig = pageFeatureConfig.get(this.pageVersion);
    return pageConfig ? pageConfig.pageType === LandingPageType.SPLIT : false;
  }

  /** 是否为：哈臻快a面协议 */
  private get isRechargeContract() {
    const pageConfig = pageFeatureConfig.get(this.pageVersion);

    return pageConfig ? pageConfig.evokeAppType === EvokeAppTypeEnums.RECHARGE : false;
  }

  // 是否同意协议
  private isChecked = false

  private onContractClick() {
    if (this.isRechargeContract) {
      /** noLogin=1 表示未登录状态下，打开协议页 */
      jumpToRechargeH5(RechargeH5RouteEnum.LEGAL_CONTRACT, `useType=${ContractSceneEnum.A_MARKET}&noLogin=1`);
    } else if (pageFeatureConfig.get(this.pageVersion)?.isAutoLogin) {
      jumpToLocal(
        getAutoLoginLegalContractRoute(),
        true,
      );
    } else {
      this.$router.push({
        path: RouterV2Enum.legalConstract,
        query: {
          contractType: String(AgreementTypeEnum.MARKET),
          sceneType: String(AgreementSceneType.SMS),
          isNeedLogin: 'false',
        },
      });
    }
  }

  private onContractCheckedChange(checked: boolean) {
    this.isChecked = checked;
  }

  // 登录过程中遇到的各类报错的回调
  private loginErrorCallBack(error: LoginError) {
    if (error.type === LoginErrorType.EmptyPhoneNum
      || error.type === LoginErrorType.EmptySmsNum
      || error.type === LoginErrorType.LoginRequestError
      || error.type === LoginErrorType.SendSmsMsgRequestError) {
      // 短信验证码发送失败 埋点
      if (error.type === LoginErrorType.SendSmsMsgRequestError) {
        this.$ubtModuleExpose(
          'finance_smsMarketing_landingPage_otpFailed',
          'pageVersion',
          this.pageVersion,
        );
      }
      // 登录失败埋点
      if (error.type === LoginErrorType.LoginRequestError) {
        this.$ubtModuleExpose(
          'finance_smsMarketing_landingPage_loginFailed',
          'pageVersion',
          this.pageVersion,
        );
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      Toast(error.message);
    } else if (error.type === LoginErrorType.ContractsUnchecked) {
      // 协议未勾选
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      Toast('请阅读并勾选协议后继续');
    }
  }

  private sendSmsMsg() {
    this.$ubtPageButton(
      'finance_smsMarketing_landingPage_otp',
      'pageVersion',
      this.pageVersion,
    );

    this.$ubtModuleExpose(
      'finance_smsMarketing_landingPage_otpSucceed',
      'pageVersion',
      this.pageVersion,
    );
  }

  // 登录按钮点击事件
  private loginBtnClickEvent() {
    this.$ubtPageButton(
      'finance_smsMarketing_landingPage_login',
      'pageVersion',
      this.pageVersion,
    );
  }

  // 登录成功
  private async loginCbWithOutInfo(
    originUserInfo: NativeModel.OriginUserInfo,
    callBackAction?: CallBackActionEnum,
  ) {
    // 登录信息更新到 base store
    updateModuleState('base', {
      originUserInfo,
    });
    // 金融用户信息获取
    await Bootstrap.throughGate();

    await Promise.all([
      this.isRechargeContract
        ? AgreementApi.markRechargeAppContracts(this.orgFinanceAgreementList)
        : AuthorizationApi.agree(this.agreementsTypeId.finance, codeEnums.app),
      AgreementApi.markUserAgreements(this.agreementsTypeId.platform),
    ]);

    /**
     * 登录成功后上报埋点信息
     * 历史需求：http://wiki.hellobike.com/pages/viewpage.action?pageId=333118796
     * 信息流落地页登陆事件  投放登录归因要用到这个埋点，不能删除
     *
     */
    this.$ubtModuleExpose(
      'finance_smsMarketing_landingPage_loginSucceed',
      'pageVersion',
      this.pageVersion,
    );

    // 获取链接上的orderId,撞库需要传入
    const { orderId } = URLUtils.getQueryMap();

    // 臻有钱用户外投注册登录信息落库
    await postLoginInfo(
      landData.getSouce(),
      orderId as string | undefined,
    );

    // 登录完，回调处理
    if (this.isAbtest || (callBackAction && callBackAction === CallBackActionEnum.DOWNLOAD)) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      Toast.loading({
        message: '提交成功，请稍候！',
        duration: 1000,
        forbidClick: true,
      });

      // 登陆完关闭验证码弹窗，防止用户可重复点击
      if (this.$refs && this.$refs.outRelease) {
        this.$refs.outRelease.closeMessagePop();
      }
      // 默认 ab 分流流程
      this.redirectApp();
    } else {
      // 跳转 h5资料页逻辑
      jumpToVerifyCredit(VerifySceneEnum.MARKET_PRE_SUPPLEMENT, {
        queryParams: {
          type: 'fromSms', // 短信营销场景
        },
      });
    }
  }

  private get submitText(): string {
    if (this.isAbtest) {
      return '立即注册';
    }
    return '登录';
  }

  private render() {
    return (
        <div class={style.NewPageWithLogin} ref="newPage">
            {!this.splitVersion
            && <Login
                mainBgColor={this.currentConfig.mainBgColor}
                topImgUrl={this.currentConfig.topImgUrl}
                title={this.currentConfig.title}
                rightImgUrl={this.currentConfig.rightImgUrl}
                contracts={this.ruleName}
                contractsChecked={this.isChecked}
                onContractClick={this.onContractClick.bind(this)}
                onContractCheckedChange={this.onContractCheckedChange.bind(this)}
                loginErrorCallBack={this.loginErrorCallBack.bind(this)}
                onSendSmsMsg={this.sendSmsMsg.bind(this)}
                onLoginBtnClickEvent={this.loginBtnClickEvent.bind(this)}
                submitText={this.submitText}
                loginClassName={style.loginBtn}
                setUser={false}
                onLoginCbWithOutInfo={this.loginCbWithOutInfo.bind(this)}
            /> }
            {this.splitVersion
            && <OutRelease
                contracts={this.ruleName}
                pageVersion={this.pageVersion}
                onConfirm={this.loginCbWithOutInfo.bind(this)}
                onContractClick={this.onContractClick.bind(this)}
                ref="outRelease"
              />}
             {this.showLeavingPop && <AdvMarketingBackPopup/>}
        </div>
    );
  }
}
